import { Meal } from './meal'
import type { Meal as PopsMeal } from '@/types/pops'

export class SakaraClassicMeal extends Meal {
  classicMealProperty: {
    classicsNumber: number
    mealSwap: string
    deliveryCycle: number
  }

  constructor(rawMeal: PopsMeal) {
    super(rawMeal)

    const {
      classics_number: classicsNumber,
      meal_swap: mealSwap,
      delivery_cycle: deliveryCycle,
    } = rawMeal.classic_meal_property
    this.classicMealProperty = { classicsNumber, mealSwap, deliveryCycle }
  }

  get mealCode() {
    return this.classicMealProperty.mealSwap
  }
}
